import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';

import { PASSWORD_ICON_TYPES, PASSWORD_HIDDEN_ICON } from './constants';
import { IconButton } from '@eventbrite/eds-icon-button';
import './password.scss';

export default class PasswordIconButton extends React.PureComponent {
    static propTypes = {
        iconType: PASSWORD_ICON_TYPES,
        togglePasswordVisibility: PropTypes.func,
        showIcon: PropTypes.bool,
    };

    static defaultProps = {
        iconType: PASSWORD_HIDDEN_ICON,
        showIcon: false,
    };

    render() {
        const { iconType, togglePasswordVisibility, showIcon } = this.props;
        const wrapperClassName = classNames('eds-password-icon__wrapper', {
            'eds-password-icon__wrapper--visible': showIcon,
        });

        return (
            <div className={wrapperClassName} data-spec="password-icon-button">
                <IconButton
                    onClick={togglePasswordVisibility}
                    title={gettext('password visibility button')}
                    iconType={iconType}
                />
            </div>
        );
    }
}
